import { render, staticRenderFns } from "./skus.vue?vue&type=template&id=da2406bc&scoped=true"
import script from "./skus.vue?vue&type=script&lang=js"
export * from "./skus.vue?vue&type=script&lang=js"
import style0 from "./skus.vue?vue&type=style&index=0&id=da2406bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2406bc",
  null
  
)

export default component.exports